<template>
  <router-view :test="reloadMainSite"></router-view>
</template>

<script>
import { NotificationNavRouter } from '@/router'
import { mapGetters } from 'vuex'

export default {
  name: 'NotificationsNavigation',
  router: NotificationNavRouter,
  created: function () {},
  props: {},
  data: () => ({}),
  computed: {
    ...mapGetters(['isNotificationNavActive']),
    reloadMainSite: function () {
      if (this.isNotificationNavActive && !this.$router.currentRoute.name) {
        this.mainSite()
      }
    }
  },
  methods: {
    mainSite () {
      this.$router.currentRoute.name !== 'Notifications' &&
        this.$router.push({ name: 'Notifications' })

      // this.$router.push({ name: 'Notifications' })
    }
  },
  mounted: function () {
    this.$emit('navigatorLoaded')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/NotificationsNavigation.vue